import { LOCALES, KEYS } from '../constants';

const deDETranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_GERMAN_DE]: {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"Partnerrolle",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"Integrator",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"Provider",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"Partnerstufe",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"Partnerspezialisierung",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:"Cisco Powered Service",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"Partnername",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"Standort",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"Land",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"Partnername – Schlüsselwort",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"Partnername – Schlüsselwörter",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"Sortierung",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"Spezialisierungen",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"Partnerspezialisierungen",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"Providerstufe und Cisco Powered Services",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"Gold-Provider",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"Premier-Provider",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"Provider auswählen",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"Unterstützung erhalten",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"Kostenvoranschlag anfordern",
    [KEYS.L18N_KEY_LABEL_OPEN ]:"Öffnen",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"Erweitern",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"Reduzieren",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"Land/Region auswählen",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"Rolle auswählen",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"Spezialisierung(en) auswählen",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"Cisco Powered Service(s) auswählen",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"Fachkenntnis(se) auswählen",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"Stufe(n) auswählen",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"Land/Region des Partners",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"Integratorstufen",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"Providerstufen",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"Integratorspezialisierungen",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"Cisco Powered Services",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"Partnernamen",
    [KEYS.L18N_KEY_LABEL_BACK ]:"Zurück",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"Alle Ergebnisse",
    [KEYS.L18N_KEY_LABEL_ALL ]:"Alle",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"Gespeichert",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"Meine Partner",
    [KEYS.L18N_KEY_LABEL_ADD ]:"Hinzufügen",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"Entfernen",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"Für Vergleich hinzufügen ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"Wählen Sie mindestens einen weiteren aus.",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"Ausgewählte vergleichen ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"Aus dem Vergleichstool entfernen",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"Vergleichen",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"Partnerstufe",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"Verarbeitung wird durchgeführt",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"Ergebnis",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"Ergebnisse",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"Keine Ergebnisse",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"Ergebnis in",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"Ergebnisse in",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"Keine Ergebnisse in",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"Zurück",
    [KEYS.L18N_KEY_LABEL_PREV ]:"Vorherige",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"Weiter",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"Speichern",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"Fachkenntnisse",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"Übersicht",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"ist ein Cisco",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"Integratoren erstellen End-to-End-Lösungen für unsere Kunden. Sie führen Transaktionen hauptsächlich im Rahmen eines Wiederverkaufs durch, lösen jedoch geschäftliche Kundenprobleme mit Ihrem eigenen Fachwissen.",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"Provider sind Experten für die Bereitstellung von gemanagten Lösungen und Cloud-Lösungen. Kunden fordern mehr Flexibilität bei der Nutzung von Lösungen. Deshalb werden Provider auf dem Markt immer wichtiger.",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"Frühere Suchen",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"Frühere Suche",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"Rollen ",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"Technologie",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"Branchen",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"Integratoren",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"Provider",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"Andere",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"Andere",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"Keine anderen Partner gespeichert",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"Keine Integratoren gespeichert",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"Keine Provider gespeichert",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"Filtern nach Bedarf",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"Suche nach kombinierten Kriterien",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"Suche nach Standort",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"Es gibt einen Partner weltweit.",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"Es gibt",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"Partner weltweit.",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"Es gibt weltweit keine Partner.",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"Es gibt 1 Partner in",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"Partner in",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"Es gibt keine Partner in",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"Standort ändern",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"Filtern nach Anforderung",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"Suchen",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"nach Name, Stufe und Fachwissen",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"ausgewählt",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"Keine Übereinstimmungen gefunden",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"Rang – Aufsteigend",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"Rang – Absteigend",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"Name – Aufsteigend",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"Name – Absteigend",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"Anmeldung erforderlich",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"Sie müssen angemeldet sein, um diese Aktion durchführen zu können.",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"Die Wiederherstellung der Suche ist fehlgeschlagen.",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"Anmelden",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"Partner erfolgreich gespeichert",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"Der Partner konnte nicht gespeichert werden",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"Partner erfolgreich entfernt",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"Der Partner konnte nicht entfernt werden",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"Geben Sie ein Schlüsselwort ein, um nach Name, Stufe oder Fachkenntnissen zu suchen",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"Entwickler sind Experten, die maßgeschneiderte Software- und Hardwarelösungen auf Basis der Cisco Technologie entwickeln. Das Ergebnis sind einzigartige Lösungen, die systemübergreifend Ergebnisse erzielen.",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"Berater sind Experten mit fundiertem Branchenwissen, die Unternehmen bei der Suche nach Lösungen für komplexe geschäftliche Herausforderungen unterstützen.",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"Unterschiedliche Partner",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"Alphabetisch",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"Meistes Fachwissen",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"Entwickler",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"Berater",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"Filter",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"Filter",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"Fachkenntnisse des Partners",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"Verwerfen",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"Spezialisierung",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"Fachkenntnisse",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"Keine Beschreibung angegeben.",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"Allgemeines",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"Vergleich löschen",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"Partnervergleich",
    [KEYS.L18N_KEY_LABEL_ROLE]:"Rolle",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"Technologischer Fokus",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"Beschreibung",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"Sprache auswählen",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"Abmelden",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"Inklusiver Partner",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "Über Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Kontaktieren Sie uns",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Karriere",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Lernen Sie unsere Partner kennen",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Feedback",
    [KEYS.L18N_KEY_LABEL_HELP]: "Hilfe",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Allgemeine Geschäftsbedingungen",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Datenschutzerklärung",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Warenzeichen",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Transparenz der Lieferkette",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Sitemap",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "Über Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Kontaktieren Sie uns",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Karriere",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Lernen Sie unsere Partner kennen",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Feedback",
    [KEYS.L18N_KEY_LABEL_HELP]: "Hilfe",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Allgemeine Geschäftsbedingungen",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Datenschutzerklärung",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Warenzeichen",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Transparenz der Lieferkette",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Sitemap",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "Kaufanleitung",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "Partner",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "Produkte und Dienstleistungen",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "Lösungen",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "Unterstützung",
    [KEYS.L18N_KEY_LABEL_LEARN]: "Lernen",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "Cisco entdecken",
    [KEYS.L18N_KEY_LABEL_MENU]: "Menü",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "Schließen",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "Mehr anzeigen",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "Weniger anzeigen",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "Sie haben kein Konto?",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "anmelden"
  }
});

export default deDETranslations;
